function e(r) {
  return r.replace(/#|\(|\)|,|\s|\./g, "_");
}
export {
  e as color2Class
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/css/color-to-class.js
// module id = 936
// module chunks = 67